import {useEffect, useState} from "react";
import {INews} from "../../../entities/news";
import {useNavigate} from "react-router-dom";
import newsData from "../../../assets/data/news.json";
import styles from "./style.module.scss";
import './style.scss';

export const FullNewsPage = ({postTitle}: { postTitle: string }) => {
    const [news, setNews] = useState<INews | undefined>();
    const navigate = useNavigate();

    useEffect(() => {
        const foundNews = newsData.find(
            (n: INews) => n.active && n.title.toLowerCase() === postTitle.toLowerCase()
        );
        setNews(foundNews);
    }, [postTitle]);

    return (
        <div className={styles.full_news_container}>
            {news && (
                <article className={styles.post}>
                    <header className={styles.header}>
                        <button
                            className={styles.more_button}
                            onClick={() => navigate("/neuigkeiten")}
                        >
                            Zurück
                        </button>
                        <div className={styles.info}>
                            <span className={styles.category}>{news.category}</span>
                            <span className={styles.date}>{news.date}</span>
                        </div>
                    </header>

                    <section className={styles.main_post}>
                        {news.image && (
                            <img src={news.image} alt="news" className={styles.image}/>
                        )}
                        <div className={styles.content}>
                            <h1 className={styles.title}>{news.title}</h1>
                            <div
                                className={styles.description}
                                dangerouslySetInnerHTML={{
                                    __html: news.description.replace(/\n\n/g, "<br /><br />"),
                                }}
                            />
                        </div>
                    </section>
                </article>
            )}
        </div>
    );
};
